/**
 * api接口
 */

import { Post } from "./axios"
import { loginDomain } from './env'

export const reqCode = (userInfo) => {
  return Post(loginDomain + '/code', userInfo)
}

export const login = (userInfo) => {
  return Post(loginDomain + '/login', userInfo)
}